import { useSuspenseQuery } from "@tanstack/react-query";
import { getImageCompressionSettings } from "../openapi/api-client.ts";
import { LoadImageCompressionSettingsError } from "../errors/LoadImageCompressionSettingsError.ts";

export const useImageCompressionSettings = (
  projectId?: string,
  appInstallationId?: string,
) =>
  useSuspenseQuery({
    queryKey: ["imageCompressionSettings", { projectId, appInstallationId }],
    queryFn: async () => {
      if (!projectId || !appInstallationId) {
        throw new Error("projectId and appInstallationId are required");
      }

      const response = await getImageCompressionSettings({
        path: { projectId, appInstallationId },
      });

      if (response.error) {
        throw new LoadImageCompressionSettingsError(
          response.error.message ||
            `error while fetching image compression settings`,
        );
      }

      return response.data;
    },
    staleTime: 1000 * 60 * 60, // 1 hour
  });
